import { render, staticRenderFns } from "./TempSpuShopPoiNewField.vue?vue&type=template&id=ffe9e876&scoped=true"
import script from "./TempSpuShopPoiNewField.vue?vue&type=script&lang=ts"
export * from "./TempSpuShopPoiNewField.vue?vue&type=script&lang=ts"
import style0 from "./TempSpuShopPoiNewField.vue?vue&type=style&index=0&id=ffe9e876&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe9e876",
  null
  
)

export default component.exports